export const setDropdownBySortPreference = async (
  projectId,
  options,
  optionDetails,
  orderAscRef,
  ascOrderIcon,
  descOrderIcon,
  groupName,
  tags,
  defaultApiParameter,
  userPreference,
  preferredSortIndexRef,
  sortBy
) => {
  if (
    userPreference &&
    userPreference.length > 0 &&
    userPreference[0].settingValue
  ) {
    let preferredSortingApiParameter = '';
    let preferredSortingIndex = -1;
    // eslint-disable-next-line no-restricted-syntax
    for (const key in optionDetails) {
      if (optionDetails[key].apiParameter === sortBy) {
        preferredSortingApiParameter = optionDetails[key].apiParameter;
        preferredSortingIndex = optionDetails[key].index;
        break;
      }
    }
    if (preferredSortingApiParameter) {
      options[0].icon = '';
      options[preferredSortingIndex].icon =
        orderAscRef.current === true ? ascOrderIcon : descOrderIcon;
      if (preferredSortingIndex !== -1) {
        preferredSortIndexRef.current = preferredSortingIndex;
      }
      return [options, preferredSortingApiParameter];
    }
  }
  return [];
};
